import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "billingDashboard",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Billing details...",
      detailsWorkOrder: {
        id: "",
        name: "",
        work_order_line_items: [],
      },
      sortBy: "name",
      lineItemsSortBy: "item_date",
      lineItemsFields: [
        { key: "item_date", label: "Date", sortable: true },
        { key: "quantity", label: "Quantity", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "rate", label: "Rate", sortable: true },
        { key: "total", label: "Total", sortable: true },
      ],
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "client", label: "Client", sortable: true },
        { key: "client_field", label: "Field", sortable: true },
        { key: "commodity", label: "Commodity", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  created() {
    this.loadBillingDashboards().then(() => {
      this.dataLoaded = true;
    });
  },
  methods: {
    loadBillingDashboards() {
      const jsConn = new JSConn();
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("needBillingDashboards", jsConn)
          .then(jsConn => {
            if (this.completedWorkOrders.length > 0) {
              this.loadDetailsWorkOrder(this.completedWorkOrders[0]);
            } else {
              this.loadDetailsWorkOrder({
                name: "No details",
                id: "",
                work_order_line_items: [],
              });
            }
            resolve(jsConn);
          })
          .catch(jsConn => {
            reject(jsConn);
          });
      });
    },
    loadDetailsWorkOrder(workOrder) {
      this.detailsWorkOrder.name = workOrder.name;
      this.detailsWorkOrder.id = workOrder.id;
      this.detailsWorkOrder.total = workOrder.total;
      this.detailsWorkOrder.work_order_line_items =
        workOrder.work_order_line_items;
    },
    archiveWorkOrder(workOrder) {
      const jsConn = new JSConn();
      jsConn.formParams = {
        id: workOrder.id,
        status: "archived",
      };
      // this seems to be happening fast enough
      // that it isn't necessary to show a loading icon
      // if it get's slower, this line should be uncommented
      // this.dataLoaded = false;
      this.$store
        .dispatch("updateWorkOrder", jsConn)
        .then(() => {
          return this.loadBillingDashboards();
        })
        .then(() => {
          this.dataLoaded = true;
          return Promise.resolve();
        });
    },
  },
  computed: {
    completedWorkOrders: function() {
      return this.$store.getters.completedWorkOrders;
    },
    showDetailsWorkOrder: function() {
      if (this.detailsWorkOrder.work_order_line_items.length > 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
